"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpheresBackground = void 0;
var react_transition_group_1 = require("react-transition-group");
var react_1 = __importStar(require("react"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var c = (0, BemBuilder_1.default)("spheres-background");
var SpheresBackground = (0, mobx_react_1.observer)(function (_a) {
    var inPersonalDetails = _a.inPersonalDetails, spheresBackgroundManager = _a.spheresBackgroundManager;
    (0, react_1.useEffect)(function () {
        if (inPersonalDetails) {
            var decayInterval_1 = setInterval(function () {
                spheresBackgroundManager.decaySphereSaturation();
            }, 500);
            return function () {
                clearInterval(decayInterval_1);
            };
        }
    }, [inPersonalDetails, spheresBackgroundManager]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: c("noise-overscroll") }),
        react_1.default.createElement(react_transition_group_1.Transition, { appear: true, in: true, timeout: 1000 }, function (status) { return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
            var _a;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), c(undefined, status), (_a = {},
                    _a[c(undefined, "personal-details")] = inPersonalDetails,
                    _a)), ref: spheresBackgroundManager.spheresRef }, [1, 2, 3, 4].map(function (index) { return (react_1.default.createElement("div", { className: c("sphere"), key: index },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("sphere-inner"), c("sphere-inner", index.toString())) }))); })));
        })); }),
        react_1.default.createElement("div", { className: c("noise") })));
});
exports.SpheresBackground = SpheresBackground;
